import { render, staticRenderFns } from "./EvolucaoFaturamento.vue?vue&type=template&id=77da52f2"
import script from "./EvolucaoFaturamento.vue?vue&type=script&lang=js"
export * from "./EvolucaoFaturamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports